module.exports = __webpack_public_path__ + "img/united2-cover-1.1740e113.jpg";